export default __webpack_public_path__ + "static/media/bgVideo.dcecc26e.mp4";